// Session storage keys for timezone information
const TIMEZONE_STORAGE_KEY = 'user_timezone_info';

/**
 * Calculate user's timezone and offset information
 * @returns {Object} Object containing timezone and offset
 */
const calculateTimezoneInfo = () => {
  try {
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const now = new Date();
    const offsetMinutes = now.getTimezoneOffset(); // Returns offset in minutes, e.g., 300 for UTC-5
    const offsetHours = Math.floor(Math.abs(offsetMinutes) / 60);
    const offsetRemainingMinutes = Math.abs(offsetMinutes) % 60;
    const sign = offsetMinutes > 0 ? "-" : "+"; // UTC is ahead of places with negative offsets (east of Greenwich)
    const userOffset = `${sign}${String(offsetHours).padStart(2, '0')}:${String(offsetRemainingMinutes).padStart(2, '0')}`;
    return {
      timezone: userTimezone,
      offset: userOffset
    };
  } catch (e) {
    console.error('Error calculating user timezone info:', e);
    return {
      timezone: 'UTC',
      offset: '+00:00'
    };
  }
};

/**
 * Get user's timezone and offset information
 * Retrieves from session storage if available, otherwise calculates and stores it
 * @returns {Object} Object containing timezone and offset
 */
export const getUserTimezoneInfo = () => {
  try {
    // Try to get user_timezone_info from session storage first
    const storedInfo = sessionStorage.getItem(TIMEZONE_STORAGE_KEY);
    if (storedInfo) {
      return JSON.parse(storedInfo);
    }

    // If not in storage, calculate and store it
    const timezoneInfo = calculateTimezoneInfo();
    sessionStorage.setItem(TIMEZONE_STORAGE_KEY, JSON.stringify(timezoneInfo));
    return timezoneInfo;
  } catch (e) {
    console.error('Error accessing session storage for timezone info:', e);
    // Fallback to calculating without storage
    return calculateTimezoneInfo();
  }
};
